// @flow
import JQueryView, { on } from '../../common/JQueryView';

declare var $: any;

export default class FormView extends JQueryView {
  cardClientip: string;

  constructor(cardClientip: string) {
    super('.show');
    this.cardClientip = cardClientip;
  }

  @on('click #regist_now')
  onClickRegistNow() {
    $('#regist_now').removeClass('btn-outline-primary');
    $('#regist_now').addClass('btn-primary');
    $('#regist_later').removeClass('btn-primary');
    $('#regist_later').addClass('btn-outline-primary');
    $('#regist_area').show();
  }

  @on('change input[name="plan_select"]')
  onChangePlanSelect() {
    const plan = $('input[name="plan_select"]:checked').val();
    if (plan === 'regist_monthly_fee') {
      $('#label_monthly').addClass('selected');
      $('#label_annual').removeClass('selected');
    } else if (plan === 'regist_annual_fee') {
      $('#label_annual').addClass('selected');
      $('#label_monthly').removeClass('selected');
    }
  }

  @on('submit #zeus_form')
  onSubmitZeusForm() {
    let valid = true;
    if (!$('input[name="plan_select"]').is(':checked')) {
      $('#invalid_plan').show();
      valid = false;
    }

    if (!valid) {
      $('#invalid').show();
      return false;
    }

    const plan = $('input[name="plan_select"]:checked').val();
    $('<input>', {
      type: 'hidden',
      name: 'sendpoint',
      value: plan,
    }).appendTo('#zeus_form');
    $('<input>', {
      type: 'hidden',
      name: 'clientip',
      value: this.cardClientip,
    }).appendTo('#zeus_form');
    $('<input>', {
      type: 'hidden',
      name: 'money',
      value: 0,
    }).appendTo('#zeus_form');

    return true;
  }
}
